import { use } from 'react';
import {
  PageTransitionContext,
  PageTransitionNavigateContext,
  PageTransitionLinkPendingContext,
} from './PageTransitionProvider';

/**
 * A custom hook that provides the current loading state of the page transition.
 * @important Be careful when using this hook, it triggers a synchronous re-render on every route change.
 * @returns A `loading` boolean indicating if a page transition is in progress
 */
export const usePageTransition = () => use(PageTransitionContext);

/**
 * Hook to access the navigate function for programmatic navigation with transition tracking.
 * @returns A navigate function that accepts href and optional NavigateOptions
 */
export const usePageTransitionNavigate = () => use(PageTransitionNavigateContext);

/**
 * Internal hook used by Link component to update link pending state.
 * @internal
 * @returns A function to set the link pending state
 */
export const usePageTransitionLinkPending = () => use(PageTransitionLinkPendingContext);
